import { BREAKPOINTS } from "../ApplicationConfig";
import addResizeHandler from "../ResizeEventListener";
import Slider from "../slider/Slider";

const DATA_ROW_KEY = 'data-item-key';

let desktopTable       = document.getElementById('compare-table');
let desktopTableHeader = document.getElementById('compare-table-header');

export default function initComparePage()
{
    initDesktopPage();
    initMobilePage();
    initSwitcher();
}

export function initMobilePage()
{
    adaptDesktopTableHeight();

    document.querySelectorAll('.js-compare-slider').forEach(node => {
        let slider = new Slider(node, {
            type: 'slider',
            perView: 2,
            gap: 0,
            keyboard: false,
            useScrollableDots: true,
            hideNavArrows: true,
            withShadow: false,
        });

        let firstColumn = document.querySelector('.compare__table-column_left');
        let secondColumn = document.querySelector('.compare__table-column_right');

        slider.native().on('move', () => {
            let allSectors = document.querySelectorAll('.js-specifications-container');
            allSectors.forEach(node => {
                let sector = node as HTMLElement;
                sector.classList.remove('compare__table-sector_visible');
                sector.classList.add('compare__table-sector_hidden');
            });

            let index = slider.native().index;
            let leftSectors = firstColumn.querySelectorAll('.js-specifications-container');

            if (leftSectors) {
                leftSectors.forEach(node => {
                    let sector = node as HTMLElement;

                    if (sector.dataset.slideId == index){
                        sector.classList.remove('compare__table-sector_hidden');
                        sector.classList.add('compare__table-sector_visible');
                    }               
                });
            }

            let rightSectors = secondColumn.querySelectorAll('.js-specifications-container');

            if (rightSectors) {
                rightSectors.forEach(node => {
                    let sector = node as HTMLElement;

                    if (sector.dataset.slideId == index + 1){
                        sector.classList.remove('compare__table-sector_hidden');
                        sector.classList.add('compare__table-sector_visible');
                    }               
                });
            }
        });
    });

    let visibilityCheckbox = document.querySelector('.js-mobile-options-visibility-checkbox');

    if (visibilityCheckbox) {
        visibilityCheckbox.addEventListener('change', (e) => {
            let target = e.target as HTMLInputElement;

            compareMobile(!target.checked);
        });
    }

    let pinnable   = document.querySelector('.compare__sliders-wrapper');

    if (pinnable) {
        let checkpoint = document.documentElement.scrollTop + pinnable.parentElement.getBoundingClientRect().y + 225;
    
        window.addEventListener('scroll', (e) => pinSliders(pinnable, checkpoint));
        pinSliders(pinnable, checkpoint);
    }
    adaptMobileSliderHeight();
}

export function initDesktopPage()
{
    addResizeHandler(adaptDesktopTableHeight);
    addResizeHandler(initScrollButtons);

    adaptDesktopTableHeight();

    //let desktopVisibilityButtons = document.querySelectorAll('.js-desktop-options-visibility');

    let desktopVisibilityCheckbox = document.querySelector('.js-desktop-options-visibility-checkbox');

    if (desktopVisibilityCheckbox) {
        desktopVisibilityCheckbox.addEventListener('change', (e) => {
            let target = e.target as HTMLInputElement;

            equalVisibilityDesktop(!target.checked);
            adaptDesktopTableHeight();

        });
    }

    let pinnable = document.querySelector('.compare_fixed-header_hidden');

    if (pinnable) {
        let tableHeader = document.getElementById('compare-table');
        let checkpoint = document.documentElement.scrollTop + tableHeader.getBoundingClientRect().y + 350;
    
        window.addEventListener('scroll', (e) => fixProductHeader(pinnable, checkpoint));
        fixProductHeader(pinnable, checkpoint);
    }

    initScrollButtons();
}

/**
 * Добавление обработчиков на кнопки сдвига таблицы сравнения
 * @returns void
 */
function initScrollButtons()
{
    let tables = document.querySelectorAll('.compare__table_scrollable');
    // В фикс. шапке с товарами у нас используется аналогичная основной таблице 
    // укороченная таблица для полного соответствия по ширине и сдвигам слева от 
    // названий характеристик. Для расчетов сдвига и отслеживания кликов будем 
    // использовать основную таблицу с характеристиками
    if (tables.length > 1) {
        let tableWidth = tables[1].scrollWidth;

        let compareProductsCount = tables[1].querySelectorAll('.compare__table-column').length;

        let columnWidth = tableWidth / compareProductsCount;
        let controlPrev = document.querySelectorAll('.compare__scroll-button_prev');
        let controlNext = document.querySelectorAll('.compare__scroll-button_next');
        let fullOffset = 0;
        let tableVisibleWidth = tables[1].clientWidth;

        if (tableVisibleWidth < (tableWidth - 3) ) {

            document.querySelectorAll('.js-compare-scroll').forEach(node => {
                if (node.classList.contains('compare__scroll-button_next')) {
                    node.classList.remove('compare__scroll-button_hidden');
                }

                node.addEventListener('click', (e) => {
                    let control = e.target as HTMLElement;
                    let offset = 0;

                    if (control.dataset.dir === '>'){
                        offset = columnWidth;
                    }
                    if (control.dataset.dir === '<'){
                        offset = -columnWidth;
                    }

                    fullOffset = fullOffset + offset;

                    if (fullOffset >= columnWidth) {
                        controlPrev.forEach(button => {
                            button.classList.remove('compare__scroll-button_hidden');
                        });
                    } else {
                        controlPrev.forEach(button => {
                            button.classList.add('compare__scroll-button_hidden');
                        });
                    }
                    if ((tableWidth - fullOffset - tables[1].clientWidth + 1) < columnWidth ) {
                        controlNext.forEach(button => {
                            button.classList.add('compare__scroll-button_hidden');
                        });
                    } else {
                        controlNext.forEach(button => {
                            button.classList.remove('compare__scroll-button_hidden');
                        });
                    }
                    
                    tables.forEach(table => {

                        table.scrollBy({
                            top: 0, 
                            left: offset, 
                            behavior : "smooth"
                        });
                    });
                });
            });
        }
    }
}

function initSwitcher()
{
    let compareButtons = document.querySelectorAll('.js-switch-compare-group');

    if (!compareButtons) {
        return;
    }
    compareButtons.forEach(node => {
        let button = node as HTMLElement;

        button.addEventListener('click', (e) => {
            window.location.href = '/compare/?groupId=' + button.dataset.groupid;
        });
    });
}

function compareMobile(isEqualsVisible: boolean = true)
{
    let firstSlider   = document.getElementById('first-slider');
    let secondSlider  = document.getElementById('second-slider');

    let content       = document.getElementById('mobile-table-content');

    let firstId         = firstSlider.querySelector('.slider__slide_active, .glide__slide--active');
    let secondId        = secondSlider.querySelector('.slider__slide_active, .glide__slide--active');

    let firstProduct    = Number(firstId.getAttribute('data-product-id'));
    let secondProduct   = 0;

    if (secondId) {
        secondProduct = Number(secondId.getAttribute('data-product-id'));
    }

    content.innerHTML = '';

    adaptMobileSliderHeight();
}

/**
 * Переключение видимости одинаковых характеристик на большом экране
 * @param {boolean} visible - true чтобы отобразить одинаковые, false - скрыть
 */
function equalVisibilityDesktop(visible: boolean)
{
    let rows = desktopTable.querySelectorAll('.js-specifications-container [' + DATA_ROW_KEY + '^="option-"]')

    rows.forEach(item => {
        let key      = item.getAttribute(DATA_ROW_KEY);
        let isEquals = true;
        let value    = item.innerHTML;

        let values = document.querySelectorAll('.js-specifications-container [' + DATA_ROW_KEY + '="' + key + '"]')
        values.forEach(item => isEquals = isEquals && item.innerHTML.toLowerCase() === value.toLowerCase());

        if (!isEquals) {
            return;
        }

        let header = desktopTableHeader.querySelector('[' + DATA_ROW_KEY + '="' + key + '"]');

        if (visible) {
            values.forEach(item => item.classList.remove('display_none'));
            
            if (header) {
                header.classList.remove('display_none');
            }
        } else {
            values.forEach(item => item.classList.add('display_none'));
            
            if (header) {
                header.classList.add('display_none');
            }
        }
    });

    // скрытие блока, если в нем скрыты все характеристики
    desktopTable.querySelectorAll('[' + DATA_ROW_KEY + '^="sector-"]').forEach(block => {
        if (block.parentElement.querySelectorAll('[' + DATA_ROW_KEY + '^="option-"]:not(.display_none)').length > 0) {
            block.parentElement.classList.remove('display_none');
        } else {
            block.parentElement.classList.add('display_none');
        }
    });
}

/**
 * Адаптация высоты элементов таблицы на большом экране
 * @returns void
 */
function adaptDesktopTableHeight()
{
    if (desktopTableHeader) {
        desktopTableHeader.querySelectorAll('[' + DATA_ROW_KEY + ']').forEach(item => {
            let maxHeight = 0;
            let targets   = desktopTable.querySelectorAll('[' + DATA_ROW_KEY + '="' + item.getAttribute(DATA_ROW_KEY) + '"]');

            targets.forEach(target => {
                (target as HTMLElement).style.height = 'auto';

                maxHeight = maxHeight < target.clientHeight ? target.clientHeight : maxHeight
            });

            targets.forEach(target => (target as HTMLElement).style.height = maxHeight + 'px');
        });
    }
}

function adaptMobileSliderHeight()
{
    let max   = 0;
    let items = document.querySelectorAll('.js-adaptive-mobile-item');
    
    items.forEach(item => {max = max < item.clientHeight ? item.clientHeight : max});
    items.forEach(item => (item as HTMLElement).style.height = max + 1 + 'px');
}

function pinSliders(pinnable: Element, checkpoint: number)
{
    if (document.documentElement.scrollTop <= checkpoint || document.documentElement.clientWidth > BREAKPOINTS.SM) {
        document.querySelector<HTMLElement>('.compare__table-wrapper').style.paddingTop = 'initial';
        document.querySelector<HTMLElement>('.compare__table_absolute').style.paddingTop = 'initial';
        pinnable.classList.remove('compare__sliders-wrapper_fixed');
    } else {
        document.querySelector<HTMLElement>('.compare__table-wrapper').style.paddingTop = checkpoint + 'px';
        document.querySelector<HTMLElement>('.compare__table_absolute').style.paddingTop = checkpoint + 'px';
        pinnable.classList.add('compare__sliders-wrapper_fixed');
    }
}

function fixProductHeader(pinnable: Element, checkpoint: number)
{
    if (document.documentElement.scrollTop <= checkpoint) {
        pinnable.classList.add('compare_fixed-header_hidden');
    } else {
        pinnable.classList.remove('compare_fixed-header_hidden');
    }
}
